var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 131,
    viewBox: "0 0 206 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8477 0.5L96.6914 118.767C97.9065 121.25 100.479 122.461 103 122.461C105.521 122.461 108.093 121.25 109.309 118.767L167.152 0.5H205.199L145.794 121.963C143.273 127.123 137.522 130.5 131.103 130.5H74.9297C68.5102 130.5 62.759 127.123 60.2383 121.963L0.801758 0.5H38.8477Z",
    fill: "#6941E6",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV);
export default __webpack_public_path__ + "static/media/v.d9bbda5a279965176f8e9ab7656a1146.svg";
export { ForwardRef as ReactComponent };